import { KillswitchFeature } from './enums'

interface KillswitchCopy {
  title: string
  scope: string
  activeChip: string
  inactiveChip: string
  turnOnTitle: string
  turnOnDescription: string
  turnOnConfirm: string
  turnOffTitle: string
  turnOffDescription: string
  turnOffConfirm: string
  /** Success toast after the switch was turned on / off — states the outcome, not the flag. */
  turnedOnToast: string
  turnedOffToast: string
}

/** `enabled: true` = killswitch ACTIVE = processing STOPPED. Copy is written from that side. */
export const KILLSWITCH_COPY: Record<KillswitchFeature, KillswitchCopy> = {
  [KillswitchFeature.PaymentProcessing]: {
    title: 'Stop payment processing',
    scope:
      'Stops every payout to US Bank for all partners. Payouts are captured and can be replayed after the switch is turned off. Refund execution is blocked while it is on.',
    activeChip: 'Processing: Stopped',
    inactiveChip: 'Processing: Running',
    turnOnTitle: 'Stop payment processing?',
    turnOnDescription:
      'Stop payment processing for ALL partners? No payouts will reach US Bank for any partner until this is turned off. A banner shows on every Payments Ops page while it is active.',
    turnOnConfirm: 'Stop payment processing',
    turnOffTitle: 'Resume payment processing?',
    turnOffDescription:
      'Resume payment processing for all partners? Normal processing resumes immediately. Captured payouts are not replayed automatically — replay them below.',
    turnOffConfirm: 'Resume processing',
    turnedOnToast: 'Payment processing stopped for all partners',
    turnedOffToast: 'Payment processing resumed',
  },
  [KillswitchFeature.Webhooks]: {
    title: 'Disable US Bank webhooks',
    scope:
      'Captures incoming US Bank ACH, card and instant-payment webhooks instead of processing them, for all partners.',
    activeChip: 'Webhooks: Captured',
    inactiveChip: 'Webhooks: Processing',
    turnOnTitle: 'Disable US Bank webhooks?',
    turnOnDescription:
      'Capture every incoming US Bank webhook for ALL partners instead of processing it? Payment statuses will stop updating until this is turned off. A banner shows on every Payments Ops page while it is active.',
    turnOnConfirm: 'Disable webhooks',
    turnOffTitle: 'Re-enable US Bank webhooks?',
    turnOffDescription:
      'Process incoming US Bank webhooks again for all partners? Captured webhooks are not replayed automatically — replay them below.',
    turnOffConfirm: 'Re-enable webhooks',
    turnedOnToast: 'US Bank webhooks are now captured',
    turnedOffToast: 'US Bank webhooks are processed again',
  },
}
